import { render, staticRenderFns } from "./SalePage.vue?vue&type=template&id=1f35fd96&"
import script from "./SalePage.vue?vue&type=script&lang=js&"
export * from "./SalePage.vue?vue&type=script&lang=js&"
import style0 from "./SalePage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports